import styled from 'styled-components';

export const TripInfoHeadOuterWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items:center;
        justify-content: space-between;
    `
);

export const TripInfoHeadInnerWrap = styled.div(
    props => `
        width:75%;
        display: flex;
        flex-direction: column;
    `
);

export const TripInfoDetailMainWrap = styled.div(
    props => `
        display: flex;
        align-items:center
    `
);

export const HeaderMainText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font22};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};
        padding-right: ${props.theme.spacing.base};
    `
);

export const TripDaysWrap = styled.p(
    props => `
        display: flex;
        background-color: ${props.theme.colors.green.bgLightd6};
        padding: ${props.theme.spacing.small.s2} ${props.theme.spacing.small.s8};
        border-radius: ${props.theme.misc.borderRadius.base};
        font-size: ${props.theme.font.small.font11};
        color: ${props.theme.colors.green.dark};
        font-weight: ${props.theme.font.fontWeight.bold};
        margin-left: ${props.theme.spacing.base};
    `
);

export const RefundStatus = styled.div(
    props => `
        display: flex;
        background-color: ${props.theme.colors.yellow.bgLightff};
        padding: ${props.theme.spacing.small.s2} ${props.theme.spacing.small.s8};
        border-radius: ${props.theme.misc.borderRadius.base};
        font-size: ${props.theme.font.small.font11};
        color: ${props.theme.colors.yellow.darkcf};
        font-weight: ${props.theme.font.fontWeight.bold};
        margin-left: ${props.theme.spacing.base};
    `
);

export const TripInfoSubDetailsWrap = styled.div(
    props => `
        display: flex;
        align-items:center
        padding-top: ${props.theme.spacing.small.s5};
    `
);

export const CancelledInfo = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.yellow.darkcf};
        font-weight: ${props.theme.font.fontWeight.bold};
    `
);

export const CompletedInfo = styled.p(
    props => `
      font-size: ${props.theme.font.large.font14};
      color: ${props.theme.colors.green.base};
      font-weight: ${props.theme.font.fontWeight.bold};
    `
)

export const TripInfoMainText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.grey.base};
        font-weight: ${props.theme.font.fontWeight.bold};
    `
);

export const TripDetailDivider = styled.span(
    props => `
        width:.5rem;
        height: .5rem;
        background-color: ${props.theme.colors.grey.base};
        margin:0  ${props.theme.spacing.base};
        border-radius: ${props.theme.misc.borderRadius.round};
    `
);

export const TripBookingDetail = styled.p(
    props => `
        font-size: ${props.theme.font.large.font14};
        color: ${props.theme.colors.grey.dark74};
    `
)

export const TripInfoHeadViewBtnWrap = styled.div(
    props => `
        width:25%;
        display: flex;
        justify-content:flex-end;
    `
);

export const TripInfoViewBtn = styled.button(
  props => `
    outline: none;
    border: none;
    border-radius: 2rem;
    box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.2);
    background-image: linear-gradient(94deg, #53b2fe 1%, #065af3 130%);
    padding: ${props.theme.spacing.large.l12} ${props.theme.spacing.large.l25};
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.white.base};
    font-weight: ${props.theme.font.fontWeight.black};
    text-transform: uppercase;
    cursor: pointer;
  `
);

export const StarWrapper = styled.span(
  props => `
    width: 1.3rem;
    padding-top: ${props.theme.spacing.small.s5};
    padding-right: ${props.theme.spacing.small.s2};
    cursor: none;
  `
);
